import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor() {}

  public changeThemeMode(value: boolean) {
    // document.body.classList.toggle('dark', value);
    document.body.classList.toggle('dark', value);
    document.body.classList.toggle('light', !value);
    this.updateThemeModeRef(value);
  }

  public changeTheme(selectedTheme: string) {
    document.body.classList.add(selectedTheme);
    this.updateThemeRef(selectedTheme);
  }

  public updateThemeRef(themeName: string) {
    const themeAnchor = document.getElementById('app-theme');
    if (themeName === 'admia') {
      themeAnchor.setAttribute('href', '/admia-theme.css');
    }
    if (themeName === 'modern') {
      themeAnchor.setAttribute('href', '/modern-theme.css');
    }
  }

  public updateThemeModeRef(darkMode: Boolean) {
    const themeModeAnchor = document.getElementById('app-theme-mode');
    if (darkMode) {
      themeModeAnchor.setAttribute('href', '/dark-theme.css');
    } else {
      themeModeAnchor.setAttribute('href', '/light-theme.css');
    }
  }
}
